import Clarity from "@microsoft/clarity";

export const PROJECT_ID = "wln8g6724u";

function safe(fn) {
  try {
    fn();
  } catch {
    // Clarity may not be ready yet
  }
}

/**
 * Attach admin user metadata as searchable Clarity tags.
 * Searchable in dashboard: Recordings → Customised filters → Customised tags
 */
export function claritySetUser(user, role) {
  if (typeof window === "undefined" || !user) return;
  safe(() => {
    const id = user._id != null ? String(user._id) : null;
    const email = typeof user.email === "string" ? user.email : null;
    const name =
      typeof user.name === "string"
        ? user.name
        : typeof user.username === "string"
          ? user.username
          : null;

    if (id) Clarity.setTag("userId", id);
    if (email) Clarity.setTag("email", email);
    if (name) Clarity.setTag("name", name);
    if (role) Clarity.setTag("role", String(role));
    Clarity.setTag("panel", "admin");

    // Always fully record admin sessions — no sampling
    Clarity.upgrade("admin_user");
  });
}

/** Fire a named event visible as a marker in the session recording timeline. */
export function clarityEvent(event, tags) {
  if (typeof window === "undefined") return;
  safe(() => {
    Clarity.event(event);
    if (tags) {
      for (const [k, v] of Object.entries(tags)) {
        Clarity.setTag(k, String(v).slice(0, 128));
      }
    }
  });
}

export function clarityTrackLogin() {
  clarityEvent("admin_login");
}

export function clarityTrackLogout() {
  clarityEvent("admin_logout");
}
